import React from "react";
import Button from "../Button/Button";
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from "prop-types";
import Checkbox from "./Checkbox";

const EditButton = (props) => {

  const {
    link,
    model,
    isLoading,
    formData,
    originalFormDataModel,
    disabledOnChangeByKeys = null,
    fullWidth,
    className,
    size,
    color,
  } = props
  const propsUpdate = cloneDeep(props)
  propsUpdate.className = className
  propsUpdate.disabled = isLoading
  propsUpdate.size = (size)?size:'s'
  propsUpdate.color = (color)?color:'grey'
  propsUpdate.fullWidth = fullWidth

  let warning = null

  if (!isLoading) {

    //todo maybe add more replaces

    propsUpdate.link = link.replace('%id', model.id)
  }

  if (disabledOnChangeByKeys && formData.isChanged){

    let isChanged = false;

    disabledOnChangeByKeys.map((disabledOnChangeByKey) => {
      if (originalFormDataModel[disabledOnChangeByKey] !== formData.model[disabledOnChangeByKey]){
        isChanged = true
      }
      return disabledOnChangeByKey;
    })

    if (isChanged){
      propsUpdate.disabled = true
      warning = 'Je moet eerst OPSLAAN of ANNULEREN voordat je deze knop kan gebruiken'
    }
  }

  return (
    <>
      {warning && <div className="color-red">{warning}</div>}
      <Button {...propsUpdate} />
    </>
  )
}

Checkbox.propTypes = {
  disabledOnChangeByKeys: PropTypes.array,
}

export default EditButton
